import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthStore } from '../store/auth.store';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceGuard implements CanActivate {
  constructor(
    private authStore: AuthStore,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const appConfig = this.authStore.appConfig();
    const isUnderMaintenance = appConfig?.under_maintenance === true;
    const targetUrl = state.url;

    // Si estamos en mantenimiento y NO estamos intentando ir a maintenance, redirigir
    if (isUnderMaintenance && !targetUrl.startsWith('/maintenance')) {
      return this.router.createUrlTree(['/maintenance']);
    }

    // Si NO estamos en mantenimiento y estamos intentando ir a maintenance, redirigir al home
    if (!isUnderMaintenance && targetUrl.startsWith('/maintenance')) {
      return this.router.createUrlTree(['/']);
    }

    return true;
  }
}
